import React from 'react';
import * as env from 'config/environment';
import { useRouting } from 'hooks/useRouting';
import Modal2 from 'components/commons/modal/Modal2';
import { isPremium } from '../utils/userStatus';

export const AlignmentPreparationModal = ({
  isShow,
  hide,
}: {
  isShow: boolean;
  hide: () => void;
}) => {
  const routing = useRouting();
  const firstRoute = routing.getFirstRoute();

  const redirectURI = `${env.appURL}/moneytreelink`;
  const scopes = [
    'guest_read',
    'accounts_read',
    'transactions_read',
    'investment_accounts_read',
    'investment_transactions_read',
    'points_read',
    'life_insurance_read',
    'request_refresh',
  ];
  const state = new Date().getTime();

  const moneytreeAuthorizeURL = encodeURI(
    `${env.moneytreeBaseURL}/oauth/authorize?client_id=${
      env.moneytreeClientId
    }&redirect_uri=${redirectURI}&response_type=code&scope=${scopes.join(
      ' '
    )}&locale=ja&state=${state}:${firstRoute.path}`
  );

  // マネーツリーへ遷移する前にルーティング操作を切り替える
  const handleMoneytreeLink = () => {
    routing.finishNormalRouting();
    // 1つ前の画面へ戻るのでルーティング上も戻しておく
    routing.backRouting(false);
  };

  const goMoneytree = (): void => {
    handleMoneytreeLink();
    window.location.href = `${moneytreeAuthorizeURL}`;
  };

  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto text-bluegray-700">
          <div className="flex flex-row">
            <div className="icon-alert items-start mr-2 mt-1 text-upcolor"></div>
            <div className="font-bold text-base">連携準備中です</div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="mt-4 text-sm">
            こちらの証券口座は連携準備中です。
            <br />
            Moneytree IDを連携することで一部の資産情報を取得できます。
          </div>
          <div className="mt-4 mb-2 text-sm font-bold">
            Moneytreeから取得できる情報
          </div>
          <img
            src="/static/images/data_renkei_table_MT.jpg"
            className="p-2"
            alt=""
          />
          <div className="mt-2 text-xs text-bluegray-500">
            ※Moneytree連携はみんかぶプレミアム会員限定機能です。
          </div>
          {isPremium() ? (
            <div
              className="mt-4 text-link text-sm cursor-pointer underline"
              onClick={() => goMoneytree()}>
              Moneytree IDを連携する
            </div>
          ) : (
            <div className="mt-4 text-link text-sm cursor-pointer underline">
              <a
                href={`https://support.minkabu.jp/hc/ja/articles/4405386766489-Moneytree%E9%80%A3%E6%90%BA%E3%81%A8%E3%81%AF`}
                target="_blank"
                rel="noopener noreferrer">
                Moneytree連携とは
              </a>
            </div>
          )}
        </div>
      </Modal2>
    </>
  );
};
